import React from 'react';

const AdministrationAutomatedInvoicesIndex = React.lazy(() => import("./index"))
const NewAdministrationAutomatedInvoices = React.lazy(() => import("./new"))
const AdministrationAutomatedInvoicesReview = React.lazy(() => import("./review"))

export default[
	{path:'/administration/automated_invoices/review',exact:true,component: AdministrationAutomatedInvoicesReview,name:'Invoice Review Mode'},
	{path:'/administration/automated_invoices/review/:id',component: AdministrationAutomatedInvoicesReview,name:'Invoice Review Mode'},
	{path:'/administration/automated_invoices/new',component: NewAdministrationAutomatedInvoices,name:'New AdministrationAutomatedInvoice'},  
	{path:'/administration/automated_invoices',component: AdministrationAutomatedInvoicesIndex,name:'AdministrationAutomatedInvoices'}, 
]

// import AdministrationAutomatedInvoicesRoutes from "modules/administration/automated_invoices/web/routes"
// routes = _.concat(routes,AdministrationAutomatedInvoicesRoutes)
